import { FixedHeaderSection } from '@sportybot-web/components/layout/fixed-header-section/fixed-header-section';
import { ClipNav } from '@sportybot-web/features/clips/components/clip-nav/clip-nav';
import { clipsSearchSchema } from '@sportybot-web/features/clips/schema/clips-search-schema';
import { createFileRoute, Outlet, stripSearchParams } from '@tanstack/react-router';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_authenticated/clips')({
  component: RouteComponent,
  validateSearch: clipsSearchSchema,
  search: {
    middlewares: [stripSearchParams({ limit: 16, page: 0 })],
  },
});
/* eslint-enable perfectionist/sort-objects */

function RouteComponent() {
  return (
    <FixedHeaderSection>
      <ClipNav />
      <Outlet />
    </FixedHeaderSection>
  );
}
